// @flow
import React from 'react';
import Flex from '@waglabs/flex';
import Text from '@waglabs/text';
import type { Route } from 'NavigationTypes';

import TrackableLink from '../../../Tracking/TrackableLink';
import {
  COMING_SOON,
} from '../../../../constants';

type Props = {
  ...Route,
  onMouseEnter: () => void,
  isActive: boolean,
  currentPathname: string,
};

const NavigationSubItem = ({
  currentPathname,
  isActive,
  label,
  onMouseEnter,
  path,
  status,
}: Props) => (
  <TrackableLink
    destinationUrl={String(path)}
    utmParams={{
      utm_medium: currentPathname,
    }}
  >
    <Flex
      height={60}
      width={200}
      px={3}
      alignItems="center"
      onMouseEnter={onMouseEnter}
      bg={isActive ? 'wagGreen' : 'white'}
    >
      <Text
        fontFamily="body"
        color={isActive ? 'white' : 'medGray'}
        textDecoration="none"
        fontSize={[2, 4]}
        m={0}
        hover
      >
        {label}
      </Text>
      {status === COMING_SOON && (
        <Text
          color={isActive ? 'white' : 'wagGold'}
          display="inline-block"
          fontFamily="heading"
          fontSize={2}
          ml={1}
        >
          Coming Soon!
        </Text>
      )}
    </Flex>
  </TrackableLink>
);

export default NavigationSubItem;
